import React from "react";
import "../Roadmap/Roadmap.css";
import abtbg2 from "../../Assets/images/roadmap-side-asset.webp";
import line from "../../Assets/images/roadmap-line-bg.webp";

const Roadmap = () => {
  return (
    <>
      <section className=" py-8 md:py-12 roadmap-sec relative   ">
        <img src={line} alt="" className="img-line" />

        {/* <div className="section_roadmap-bg-gradient" /> */}

        <div className="container mx-auto px-4 py-8 relative">
          <div className="mb-14 text-center">
            <span className="py-2 px-4 span-bx rounded-full text-md font-medium text-[#ffe400ba] text-center">
              Roadmap
            </span>
            <h2 className="text-4xl text-center font-bold  bg-gradient-to-br from-yellow-500 via-blue-500 to-yellow-400  text-transparent bg-clip-text py-2">
              The Path to Innovation
            </h2>

            <p className="text-lg font-normal text-gray-400 max-w-md md:max-w-2xl mx-auto">
              Our Roadmap to success.
            </p>
          </div>
          <div className="roadmap__main max-w-5xl  mx-auto">
            <div className="roadmap-box">
              <div className="time">Quarter 03 2024</div>
              <div className="content">
                <h3 className="title">Concept Finalization</h3>
                <p className="text">
                  Finalizing Exbit’s core features including DEX, staking pools,
                  NFT farming, and blockchain games.
                </p>
              </div>
            </div>
            <div className="roadmap-box right">
              <div className="time">Quarter 04, 2024</div>
              <div className="content">
                <h3 className="title">Game Launch</h3>
                <p className="text">
                  Release blockchain-based games such as Roulette, Lottery,
                  Prediction, and Aviator, with integrated rewards and
                  leaderboards.
                </p>
              </div>
            </div>
            <div className="roadmap-box">
              <div className="time">Quarter 01, 2025</div>
              <div className="content">
                <h3 className="title"> DEX, Staking, &amp; NFT Farming</h3>
                <p className="text">
                  Launch Exbit’s Decentralized Exchange (DEX), staking pools,
                  and NFT liquidity farming with user-friendly features.
                </p>
              </div>
            </div>
            <div className="roadmap-box right">
              <div className="time">Quarter 02, 2025</div>
              <div className="content">
                <h3 className="title">Decentralized Wallet Launch</h3>
                <p className="text">
                  Release Exbit’s decentralized wallet with cross-chain token
                  swaps and seamless NFT management.
                </p>
              </div>
            </div>
            <div className="roadmap-box">
              <div className="time">Quarter 03, 2025</div>
              <div className="content">
                <h3 className="title">Blockchain Expansion</h3>
                <p className="text">
                  Expand with multi-blockchain support and decentralized
                  governance, and launch mobile apps for wider accessibility.
                </p>
              </div>
            </div>
            <div className="icon" />
            <div className="icon bottom" />
          </div>
          <div className="feature-box max-w-24  ">
            <img
              src={abtbg2}
              alt="collection-pattern"
              className="pattern  -z-10  "
            />
          </div>
        </div>
        <div className="section_roadmap-bg-gradient animate-pulse" />
      </section>
    </>
  );
};

export default Roadmap;
